module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "radio-container",
    class: [_vm.checkClasses],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleCheck.apply(null, arguments)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-checkmark"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6a7a9f21!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/plRadio/plRadio.vue
// module id = 2370
// module chunks = 61